import React from 'react';
import ScrollAnimation from 'react-animate-on-scroll';
import { BlockWrapper } from '../Preview';

export default function ScrollAnimations({ block, ...props }: any) {
    return (
        <ScrollAnimation
            offset={parseInt(block?.data?.offset) ?? 150}
            // offset={0}
            animateIn={block.data.animateIn}
            animateOut={block?.data?.animateOut ?? 'fadeOut'}
            duration={parseInt(block?.data?.duration) ?? 1}
            initiallyVisible={block?.data?.initiallyVisible ?? true}
            delay={parseInt(block?.data?.delay)}
            animateOnce={block?.data?.animateOnce ?? true}
            // animatePreScroll={true}
        >
            <BlockWrapper {...props} key={block.id} block={{ ...block, data: { ...block?.data, animationOnScroll: false } }} />
        </ScrollAnimation>
    );
}